<template>
  <v-dialog
      :value="value"
      @input="(v) => v || closeEditPlantDialog()"
      max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">発電所情報編集</span>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-container class="pb-0">
          <p>* は必須項目です。</p>
          <v-form
              ref="editPlantForm"
              v-model="editPlantFormValid"
              lazy-validation
          >
            <v-text-field
                hide-details="auto"
                class="mb-3"
                @change="plantIdChange"
                v-model="plant.plant_id"
                label="経産省ID"
                :rules="[ministryDuplicate]"
                outlined
                clearable
                dense
                @click="resetFormValidation"
            ></v-text-field>
            <v-text-field
                class="mb-3"
                hide-details="auto"
                v-model="plant.plant_name"
                label="発電所名 *"
                required
                :rules="[(v) => (!!v && !!v.trim()) || '発電所名を入力してください。', nameDuplicate]"
                outlined
                clearable
                dense
                @click="resetFormValidation"
            ></v-text-field>
            <v-text-field
                class="mb-3"
                hide-details="auto"
                @change="plantAddressChange"
                v-model="plant.plant_address"
                :label="addressLabel"
                :rules="[addressDuplicate, isAddressRequired]"
                outlined
                clearable
                dense
                @click="resetFormValidation"
            ></v-text-field>
            <v-text-field
                hide-details="auto"
                required
                outlined
                dense
                clearable
                label="DC"
                :rules="[numberRule]"
                v-model.number="plant.plant_dc"
                type="number"
                step="any"
                min="0"
                suffix="kW"
            ></v-text-field>
            <v-text-field
                hide-details="auto"
                required
                outlined
                dense
                clearable
                label="AC"
                :rules="[numberRule]"
                v-model.number="plant.plant_ac"
                type="number"
                step="any"
                min="0"
                suffix="kW"
            ></v-text-field>
            <v-autocomplete
                hide-details="auto"
                class="mb-3"
                label="支店*"
                v-model="plant.branch"
                dense
                :items="branches"
                outlined
                :rules="[(v) => (!!v) || '支店を記入してください。']"
                no-data-text="該当データがありません。"
                v-on:click="resetFormValidation"
                :item-value="item => item.id"
                :item-text="item => item.name"
            ></v-autocomplete>
            <v-autocomplete
                hide-details="auto"
                class="mb-3"
                v-model="plant.seller"
                :items="sellers"
                dense
                label="営業者"
                outlined
                no-data-text="該当データがありません。"
                v-on:click="resetFormValidation"
                :item-value="item => item.email"
                :item-text="item => item.name"
            ></v-autocomplete>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn depressed @click="closeEditPlantDialog">キャンセル</v-btn>
        <v-btn depressed color="primary" @click="editPlant">編集</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "PlantEditDialog",
  props: ['value', 'item'],
  data(){
    return {
      ministryDuplicate: true,
      nameDuplicate: true,
      addressDuplicate: true,
      editPlantFormValid: true,
      plant: JSON.parse(JSON.stringify(this.item)),
      isAddressRequired: true,
      addressLabel: "住所",
      branch: null,
      branches: [],
      seller: null,
      sellers: [],
      numberRule: val => {
        if(val <= 0) return '０より数字を記入してください。';
        return true;
      }
    }
  },
  methods: {
    resetFormValidation() {
      this.ministryDuplicate = true;
      this.nameDuplicate = true;
      this.addressDuplicate = true;
    },
    closeEditPlantDialog() {
      this.$emit('input');
      this.resetFormValidation();
      this.$refs.editPlantForm.reset();
    },
    editPlant() {
      if (this.$refs.editPlantForm.validate()) {
        this.axios
            .put("/api/main-plant/" + this.plant.id, this.plant)
            .then(() => {
              store.showSuccessDialog("発電所情報編集が完了しました。");
              this.item.plant_id = this.plant.plant_id;
              this.item.plant_name = this.plant.plant_name;
              this.item.plant_address = this.plant.plant_address;
              this.item.plant_dc = this.plant.plant_dc;
              this.item.plant_ac = this.plant.plant_ac;
              this.item.branch = this.plant.branch;
              this.item.seller = this.plant.seller;
              this.closeEditPlantDialog();
            })
            .catch((error) => {
              if (error.response.status == 409){
                switch (error.response.data) {
                  case 'name': {
                    this.nameDuplicate = "入力された発電所名は既に登録されています。再度入力してください。";
                    break;
                  }
                  case 'ministryid':{
                    this.ministryDuplicate = "入力された経産省IDは既に登録されています。再度入力してください。";
                    break;
                  }
                  case 'address':{
                    this.addressDuplicate = "入力された住所は既に登録されています。再度入力してください。";
                    break;
                  }
                }
              }
              else if (error.response.status == 404 && error.response.data === 'ministry_id'){
                store.showErrorDialog("入力された経産省IDは基幹DBにないので、確認して再度試してください。");
              }
              else store.showErrorDialog("エラーが発生しました。再度試してください。");
            });
      }
    },
    plantIdChange(){
      if (this.plant.plant_id){
        this.addressLabel = "住所 *";
        if (this.plant.plant_address){
          this.isAddressRequired = true;
        }
        else {
          this.isAddressRequired = (v) => (!!v && !!v.trim()) || '住所が必須です。入力してください。';
        }
      }
      else {
        this.addressLabel = "住所";
        this.isAddressRequired = true;
      }
    },
    plantAddressChange(){
      if (this.plant.plant_id){
        this.addressLabel = "住所 *";
        if (this.plant.plant_address){
          this.isAddressRequired = true;
        }
        else {
          this.isAddressRequired = (v) => (!!v && !!v.trim()) || '住所が必須です。入力してください。';
        }
      }
      else {
        this.addressLabel = "住所";
        this.isAddressRequired = true;
      }
    },
    getBranches(){
      this.axios.get('/api/branch/').then((response) => {
        this.branches = response.data;
      });
    },
    getSellers(){
      this.axios.get('/api/seller/').then((response) => {
        this.sellers = response.data;
      });
    }
  },

  created() {
    this.getBranches();
    this.getSellers();
  }
}
</script>

<style scoped>

</style>
